import Vue from 'vue'
import Router from 'vue-router'


import router_main from './router_main'
import router_monev from './router_monev'
import router_bhumie from './router_bhumie'
import router_office from './router_office'
import router_planing from './router_planing'
import router_sakip from './router_sakip'
import router_registrasi from './router_registrasi'
import router_simpeg from './router_simpeg'


// import './assets/css/kiken/kiken.css'

Vue.use(Router)

var allRoutes = []
allRoutes = allRoutes.concat(router_main, router_monev, router_bhumie, router_office, router_planing, router_registrasi, router_simpeg,router_sakip)

const routes = allRoutes


export default new Router({
  routes
})